import { admin } from '../types';

const INITIAL_STATE = {
    error: undefined,
    tagsList: {},
    regionsList: [],
    tagsDropdownList: [],
    defaultMilestones: [],
    remarksData: {},
    remarksListDropdown: {},
    courierListDropdown: []
};


const adminReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case admin.GET_SIGN_OFF_TEMPLATES_SUCCESS:
            return {
                ...state,
                signOffTemplates: action.payload,
            };

        case admin.LIST_ALL_STATE_SUCCESS:
            return {
                ...state,
                allState: action.payload,
            };
        case admin.LIST_ALL_CITY_SUCCESS:
            return {
                ...state,
                allCity: action.payload,
            };

        case admin.GET_ALL_STATE_CITIES_SUCCESS:
            return {
                ...state,
                stateAllCities: action.payload,
            };
        case admin.CLEAR_STATE_CITIES_FROM_STORE:
            return {
                ...state,
                stateAllCities: undefined,
            };
        case admin.LIST_ISSUE_CATEGORIES_SUCCESS:
            return {
                ...state,
                issueCategories: action.payload,
            };
        case admin.CLEAR_ISSUE_CATEGORIES:
            return {
                ...state,
                issueCategories: null,
            };
        case admin.LIST_ALL_DISTRICT_SUCCESS:
            return {
                ...state,
                districtsList: action.payload,
            };
        case admin.LIST_ALL_LOCALITY_SUCCESS:
            return {
                ...state,
                localityList: action.payload,
            };
        case admin.CLEAR_DISTRCT_LIST_FROM_STORE:
            return {
                ...state,
                districtsList: undefined,
            };
        case admin.CLEAR_LOCALITY_LIST_FROM_STORE:
            return {
                ...state,
                localityList: undefined,
            };
        case admin.LIST_ALL_TAGS_SUCCESS: {
            const { type, data } = action.payload;
            return {
                ...state,
                tagsList: { ...state.tagsList, [type]: data },
            };
        }
        case admin.LIST_ALL_DROPDOWN_TAGS_SUCCESS: {
            const { query, data } = action.payload;
            let tags;
            if (query?.length > 0) {
                tags = [...(state.tagsDropdownList || []), ...data];
            } else {
                tags = data;
            }
            tags = Array.from(new Map(tags.map(item => [item.id, item])).values());
            return {
                ...state,
                tagsDropdownList: tags,
            };
        }

        case admin.GET_REGIONS_DATA_SUCCESS: {
            const { data, appendAtStart, page } = action.payload;
            let regionsList = state.regionsList || [];
            if (page > 1) {
                regionsList = [...regionsList, ...data];
                if (data.length === 0) {
                    regionsList[regionsList.length - 1].isLast = true;
                }
            } else {
                if (appendAtStart) {
                    regionsList = [...data, ...regionsList]
                } else {
                    regionsList = data
                }
            }
            return {
                ...state,
                regionsList
            }
        }
        case admin.GET_DEFAULT_MILESTONES_SUCCESS: {
            const defaultMilestones = action.payload
            return {
                ...state,
                defaultMilestones
            }
        }

        case admin.GET_REMARKS_SUCCESS: {
            const { category, data, page } = action.payload;
            if (page === 1) {
                return {
                    ...state,
                    remarksData: { ...state.remarksData, [category]: data }
                }
            }
            return {
                ...state,
                remarksData: { ...state.remarksData, [category]: [...state.remarksData[category], ...data] }
            }
        }

        case admin.GET_REMARKS_DROPDOWN_SUCCESS: {
            const { category, data, query } = action.payload;
            let remarks;
            if (query?.length > 0) {
                remarks = [...(state.remarksListDropdown?.[category] || []), ...data];
            } else {
                remarks = data;
            }
            remarks = Array.from(new Map(remarks.map(item => [item.id, item])).values());
            return {
                ...state,
                remarksListDropdown: { ...state.remarksListDropdown, [category]: remarks },
            };
        }

        case admin.GET_COURIER_LIST_SUCCESS: {
            const { data, query } = action.payload;
            let courierListDropdown;
            if (query?.length > 0) {
                courierListDropdown = [...(state.courierListDropdown || []), ...data];
            } else {
                courierListDropdown = data;
            }
            courierListDropdown = Array.from(new Map(courierListDropdown.map(item => [item.id, item])).values());

            return {
                ...state,
                courierListDropdown
            }
        }

        case admin.CLEAR_COURIER_LIST_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                courierListDropdown: INITIAL_STATE.courierListDropdown,
            };
        }

        case admin.CLEAR_REMARKS_LIST_DROPDOWN_LIST_DATA: {
            const category = action.payload;
            return {
                ...state,
                remarksListDropdown: { ...state.remarksListDropdown, [category]: [] },
            };
        }

        case admin.CLEAR_TAGS_DROPDOWN_LIST_DATA: {
            const type = action.payload;
            return {
                ...state,
                tagsDropdownList: INITIAL_STATE.tagsDropdownList,
            };
        }

        case admin.LIST_ALL_LOCALITY_FAILURE:
        case admin.LIST_ALL_DISTRICT_FAILURE:
        case admin.GET_SIGN_OFF_TEMPLATES_FAILURE:
        case admin.LIST_ALL_STATE_FAILURE:
        case admin.LIST_ALL_CITY_FAILURE:
        case admin.LIST_ISSUE_CATEGORIES_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default adminReducer;
